import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

function FullScreen() {
    this.defaultAttrs({
        heroContainerSelector: '[data-hero]',
        currentHeroImageSelector: '[data-hero-current]',
        sidebarContainerSelector: '[data-sidebar]',
    });

    this.activate = function() {
        this.$node.attr('data-full-screen', true);
        this.select('currentHeroImageSelector').attr('data-active', true);
        this.select('heroContainerSelector').attr('data-active', true);
        this.select('sidebarContainerSelector').attr('data-inactive', true);
    };

    this.deactivate = function() {
        this.$node.removeAttr('data-full-screen');
        this.select('currentHeroImageSelector').removeAttr('data-active');
        this.select('heroContainerSelector').removeAttr('data-active');
        this.select('sidebarContainerSelector').removeAttr('data-inactive');
    };

    this.toggle = function() {
        if (this.$node.attr('data-full-screen')) {
            this.trigger('uiDeactivateFullscreen');
        } else {
            this.trigger('uiActivateFullscreen');
        }
    };

    this.after('initialize', function() {
        this.on('uiActivateFullscreen', this.activate);
        this.on('uiDeactivateFullscreen', this.deactivate);
        this.on('click', {
            currentHeroImageSelector: this.toggle,
        });
    });
}

export default defineComponent(FullScreen);



// WEBPACK FOOTER //
// ./src/js/component_ui/full-screen.js